import { matchPath } from 'react-router';
import {RouteDefinition, RouteParams} from '../routing-configuration/route-definition/route-definition';


export interface RouteMatchResult {
    routeDefinition: RouteDefinition;
    routeParams: RouteParams;
}
export function tryMatchPath(pathToMatch: string, routes: RouteDefinition[]): RouteMatchResult {
    for(let i = 0; i < routes.length; i++) {
        let routeDefinition = routes[i];

        for(let j = 0; j < routeDefinition.paths.length; j++) {
            let pattern = routeDefinition.paths[j];
            let match = matchPath(pathToMatch, {
                path: pattern,
                exact: routeDefinition.exact,
                strict: false
            });

            if(match) {
                return {
                    routeDefinition: routeDefinition,
                    routeParams: match.params
                };
            }
        }
    }

    return null;
}